type RequestOptions = {
  token?: string
  method?: string
  body?: unknown
  signal?: AbortSignal
}

export class ApiError extends Error {
  status: number

  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

export const apiRequest = async <T>(path: string, options: RequestOptions = {}) => {
  const response = await fetch(path, {
    method: options.method ?? 'GET',
    headers: {
      ...(options.token ? { Authorization: `Bearer ${options.token}` } : {}),
      ...(options.body ? { 'content-type': 'application/json' } : {}),
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
    signal: options.signal,
  })

  const payload = await response.json().catch(() => null)

  if (!response.ok) {
    const errorMessage =
      payload && typeof payload === 'object' && 'error' in payload
        ? String((payload as { error?: unknown }).error ?? 'Запрос не выполнен')
        : 'Запрос не выполнен'
    throw new ApiError(response.status, errorMessage)
  }

  return payload as T
}
